import type { NextPage, GetServerSideProps } from 'next'
import { ParsedUrlQuery } from 'querystring'
import Image from 'next/legacy/image'
import {
  PageConfig,
  PageComponentProps
} from '../../types/page_component_types'
import { getPagePropsBySlug } from '../../utils/get_page_props_by_slug'
import { Layout, PageTemplate } from '../../components'
import { Locale } from '../../types/shared_types'

interface CohortPageContent {
  meta: {
    title: string
    description: string
  }
  image: {
    alt: string
    src: string
  }
  tags: string[]
  slug: string
  cohortName: string
  flavorText: string
  shortDescription: string
  venturesInCohort: string[]
  forumLink: string
  content: PageComponentProps[]
}

const CohortPage: NextPage<{
  pageContent: CohortPageContent
  pageConfig: PageConfig
  availableLocales?: string[]
}> = ({ pageContent, pageConfig, availableLocales }) => {
  return (
    <Layout
      config={pageConfig}
      meta={pageContent?.meta}
      slug={pageContent?.slug}
      availableLocales={availableLocales}
    >
      <div className="mx-auto flex max-w-[70.5rem] flex-col">
        <div className="relative mx-auto mb-8 mt-0 h-[27.5rem] w-full pr-6 pl-6 md:mt-8 lg:pr-0 lg:pl-0">
          <Image
            src={pageContent?.image?.src}
            alt={pageContent?.image?.alt}
            layout="fill"
            objectFit="cover"
          />
        </div>
      </div>
      {<PageTemplate {...pageContent} />}
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await getPagePropsBySlug(context, '/cohorts')
}

export default CohortPage
